// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getLanguage, setLanguage } from './utils/languageHelper';

// Import your translations
import translationEN from './content/applications/translations/en.json';
import translationAR from './content/applications/translations/ar.json';
import translationFR from './content/applications/translations/fr.json';
import translationES from './content/applications/translations/es.json';
import translationDT from './content/applications/translations/dt.json';
import translationPT from './content/applications/translations/pt.json';

const resources = {
  en: { translation: translationEN },
  ar: { translation: translationAR },
  fr: { translation: translationFR },
  es: { translation: translationES },
  pt: { translation: translationPT },
  dt: { translation: translationDT }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    react: { useSuspense: false }
  });

// Every time the language changes, sync it in cookie + localStorage
i18n.on('languageChanged', (lng) => setLanguage(lng));

export default i18n;
